import { render, staticRenderFns } from "./WatchList.vue?vue&type=template&id=73832c09"
import script from "./WatchList.vue?vue&type=script&lang=js"
export * from "./WatchList.vue?vue&type=script&lang=js"
import style0 from "./WatchList.vue?vue&type=style&index=0&id=73832c09&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports